module.exports = __webpack_public_path__ + "img/item1-2.d82850ad.png";